'use client';

import HistoryTable from 'src/components/HistoryTables/HistoryTable';
import LiquidationsTableMobileCard from 'src/components/LiquidationsTable/LiquidationsTableMobileCard';
import useUserLiquidationsTable from 'src/components/LiquidationsTable/UserLiquidationsTable/hooks/useUserLiquidationsTable';

export default function UserLiquidationsTable() {
	const {
		data,
		columns,
		isLoading,
		pagination,
		toggleDateDisplayType,
		displayDatesAsTimestamp,
		showLiquidationDetailsDrawer,
	} = useUserLiquidationsTable();

	return (
		<HistoryTable
			dataTableProps={{
				data,
				columns,
				emptyMessage: 'No liquidations found',
				className: 'w-full',
				onRowClick: showLiquidationDetailsDrawer,
				pagination,
			}}
			mobileCard={({ record: liquidation }) => (
				<LiquidationsTableMobileCard
					liquidation={liquidation}
					toggleDateDisplayType={toggleDateDisplayType}
					displayDatesAsTimestamp={displayDatesAsTimestamp}
					showLiquidationDetailsDrawer={showLiquidationDetailsDrawer}
				/>
			)}
			isLoading={isLoading}
		/>
	);
}
